import { render, staticRenderFns } from "./Grazie.vue?vue&type=template&id=e8158a12&scoped=true"
import script from "./Grazie.vue?vue&type=script&lang=js"
export * from "./Grazie.vue?vue&type=script&lang=js"
import style0 from "./Grazie.vue?vue&type=style&index=0&id=e8158a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8158a12",
  null
  
)

export default component.exports